import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";

import { getHelmet } from "../utilities";
import { FromTopPage } from "../theme";
import StoryPage from "../components/story/StoryPage";
import JoinUs from "../components/JoinUs";
import statics from "../components/story/statics";

const StoryStatic = ({ match }) => {
  const { story, StaticContent } = statics[match.params.slug];

  return (
    <FromTopPage>
      <Helmet>
        {getHelmet(
          story.title,
          story.headline_or_extract_medium,
          match.url,
          story.thumb_hero_url
        )}
      </Helmet>
      <StoryPage story={story} StaticContent={StaticContent} />
      <JoinUs />
    </FromTopPage>
  );
};

StoryStatic.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      slug: PropTypes.string.isRequired,
    }).isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default StoryStatic;
